import { secondaryFontFamily, styled } from '@openeducation/oe-rn-themes';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { OEText, OETouchableOpacity } from '../../atoms';
import CircleIconButton from '../../atoms/circle-icon-button/circle-icon-button';

export interface PlatformTourModalProps {
  onClosePress: () => void;
  onButtonPress: () => void;
}

const imageSource = require('../../assets/platform-tour/platform-tour-modal.png');

export function PlatformTourModal({
  onButtonPress,
  onClosePress,
}: PlatformTourModalProps) {
  const { t } = useTranslation();

  return (
    <Container>
      <CloseButton testID="close-button" onPress={onClosePress} name="times" />

      <Title>{t('onboarding.platformTour.title')}</Title>

      <Description>
        {t('onboarding.platformTour.modal.description')}
      </Description>

      <Button testID="cta-button" onPress={onButtonPress}>
        <ButtonText>{t('onboarding.platformTour.modal.cta')}</ButtonText>
      </Button>

      <Image source={imageSource} resizeMode="contain" />
    </Container>
  );
}

const Container = styled.View`
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding: 24px;
`;

const CloseButton = styled(CircleIconButton).attrs(({ theme }) => ({
  size: 16,
  iconSize: 16,
  color: theme.color.dark1,
  backgroundColor: theme.color.transparent,
}))`
  align-self: flex-end;
  margin-bottom: 38px;
`;

const Text = styled(OEText).attrs({
  fontFamily: secondaryFontFamily,
})``;

const Title = styled(Text)`
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
  color: ${({ theme }) => theme.color.black};
  text-align: center;
  margin-bottom: 40px;
`;

const Description = styled(Text)`
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.color.dark1};
  text-align: center;
  margin-bottom: 40px;
`;

const Button = styled(OETouchableOpacity)`
  background-color: ${({ theme }) => theme.color.accent};
  align-items: center;
  justify-content: center;
  padding: 8px 24px;
  border-radius: 32px;
`;

const ButtonText = styled(Text)`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.color.white};
  text-align: center;
`;

const Image = styled.Image`
  margin-top: 40px;
  width: 100%;
  height: 110px;
`;
